/**
 * Modules
 */
import smoothscroll from 'smoothscroll-polyfill';

/**
 * Modules
 */
import handleGoTopBtn from './modules/handleGoTopBtn';
import handleHeader from './modules/handleHeader';
import handleMenuAccordion from './modules/handleMenuAccordion';
import handleMobileNav from './modules/handleMobileNav';
import handleResponsiveVideo from './modules/handleResponsiveVideo';
import handleVideoSection from './modules/handleVideoSection';
import handleTestimonialsAnimation from './modules/handleTestimonialsAnimation';
import handleInfoCardAnimation from './modules/handleInfoCardAnimation';
import handleAnimations from './modules/handleAnimations';

// import handleLoadingMorePosts from './modules/handleLoadingMorePosts';

/**
 * Sliders
 */

import cardsSlider from './sliders/cardsSlider';
import heroSlider from './sliders/heroSlider';
import testimonialsSlider from './sliders/testimonialsSlider';
import gallerySlider from './sliders/gallerySlider';

document.addEventListener('DOMContentLoaded', () => {
  smoothscroll.polyfill();

  /**
   * Modules
   */
  handleHeader();
  handleMobileNav();
  handleMenuAccordion();
  handleResponsiveVideo();
  handleGoTopBtn();
  handleVideoSection();
  handleTestimonialsAnimation();
  handleInfoCardAnimation();
  handleAnimations();
  // handleLoadingMorePosts();

  /**
   * Sliders
   */
  heroSlider();
  testimonialsSlider();
  cardsSlider();
  gallerySlider();
});
